import { LinearProgress } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import { io } from 'socket.io-client';
import api from "../../BrandOnBoarding/api";
import Header from "../../Component/Header/Header";
import Modal from "../../Component/Modal/Modal";
import PDFFooter from "../../Component/PDFFooter/PDFFooter";
import PDFHeader from "../../Component/PDFHeader/PDFHeader";
import MUIButton from "../../Component/UI/MUIButton/MUIButton";
import Tabs from "../../Component/UI/Tabs/Tabs";
import { AuthContext } from "../../context/auth-context";
import { useDailyLimits } from "../../hooks/useDailyLimits";
import { LLM_OPTIONS } from "../../utils/constant";
import useHistory from "../BrandAudit/History/useHistory";
import classes from "./BrandAudit.module.css";
import BrandScore, { tab } from "./BrandScore/BrandScore";
import { DiscoveryContext } from "./discovery-context";
import Form from "./Form";
import History from "./History/History";
import SelectedComponent from "./SelectedComponent/SelectedComponent";

export const filterKey = {
  llm: "llm_select",
  category: "category_select",
  market: "market_select",
  competitor: "competitor_select",
};

export default function BrandAudit() {
  const [inputValues, setInputValues] = useState({
    brand: "",
    category: "",
    market: "",
    llm: "",
    type: "brand",
  });
  const [tabSelected, setTabSelected] = useState("overview");
  const [externalReportLoading, setExternalReportLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [warningText, setWarningText] = useState("");
  const [cancelTransaction, setCancelTransaction] = useState(false);
  const [showLunchDialog, setShowLunchDialog] = useState(false);
  const { user } = useContext(AuthContext);

  const transactionIdRef = useRef(null);
  const pollingRef = useRef(null);
  const {
    launchText,
    updateLaunches,
    launchesRemaining,
    isSpecial,
    frequency: launchLimitFrequency,
  } = useDailyLimits("Discovery");

  const discoveryCtx = useContext(DiscoveryContext);
  const abortControllerRef = useRef(null);
  const location = useLocation();
  const entity = discoveryCtx.entity;
  const discoveryType = discoveryCtx.type || "brand";
  const { getHistory } = useHistory(discoveryCtx.type);
  const pdfRef = useRef();
  const discoveryCtxRef = useRef(discoveryCtx);
  const rankScoreAbortCtrRef = useRef(null);
  const socketRef = useRef(null); // persists across renders
  const webSocketBaseURL = process.env.REACT_APP_ORCHESTRATOR_BASE_URL;

  const showLaunchMessage = localStorage.getItem("showLaunchMessage");

  useEffect(() => {
    if (!socketRef.current) {
      const isProd = process.env.REACT_APP_ENV === "production";

      const socketOptions = {
        reconnectionAttempts: 5,
      };

      const socketUrl = process.env.REACT_APP_SOCKET_BASE_URL;

      if (isProd) {
        socketOptions.path = "/ows/";
      } else {
        socketOptions.transports = ["websocket"];
      }

      // Initialize socket
      socketRef.current = io(socketUrl, socketOptions);

      socketRef.current.on("connect", () => {
        console.log("Socket connected:", socketRef.current.id);
      });

      socketRef.current.on("disconnect", () => {
        console.warn("Socket disconnected");
      });

      socketRef.current.on("live-data", handleSocketData);
    }

    const handleOnline = () => {
      if (socketRef.current) {
        if (!socketRef.current.connected && !socketRef.current.active) {
          console.log("Network back online, reconnecting socket...");
          socketRef.current.connect();
        } else {
          console.log("Socket already connected or reconnecting, skipping...");
        }
      }
    };

    window.addEventListener("online", handleOnline);

    return () => {
      // Optional: Cleanup if needed
      // socketRef.current?.disconnect();
      window.removeEventListener("online", handleOnline);
      transactionIdRef.current = null;
    };
  }, []);
  useEffect(() => {
    if (discoveryCtx.state.transactionId) {
      transactionIdRef.current = discoveryCtx.state.transactionId;
    }
    else {
      transactionIdRef.current = null
    }
  }, [discoveryCtx.state.transactionId]);



  useEffect(() => {
    discoveryCtxRef.current = discoveryCtx;
  }, [discoveryCtx]);



  const handleSocketData = (data) => {
    if (!data) {
      console.error("Received null or undefined socket data.");
      return;
    }
    const totalTasks = discoveryCtxRef?.current?.status?.totaltasks;
    let transactionId;
    let type, request, response, category, llm,market, transaction,completedTaskCount, coreAttributeData,commonReq;

    if (Array.isArray(data?.coreAttributeData)) {
      if (!data?.coreAttributeData[0]) {
        console.error("CoreAtribute data is empty or invalid:", data);
        return;
      }
      transactionId = data?.coreAttributeData[0]?.transaction?.transaction_id;
      type = data?.coreAttributeData[0]?.type;
      coreAttributeData = data?.coreAttributeData;
      completedTaskCount = data?.completedTaskCount;
      commonReq= {
        category: data?.coreAttributeData[0]?.category ?? "",
        llm: data?.coreAttributeData[0]?.llm ?? "",
        market: data?.coreAttributeData[0]?.market ?? "",
      }
    } else {
      ({
        type,
        request,
        response,
        category,
        llm,
        market,
        transaction,
        completedTaskCount,
      } = data);
      transactionId = transaction?.transaction_id ? transaction?.transaction_id : data?.transactionId;
      commonReq = {
        category: category ?? "",
        llm: llm ?? "",
        market: market ?? "",
      };
    }

    const currentContextTxnId = transactionIdRef.current;
    if (transactionId !== currentContextTxnId) return;
       if (data?.status === "Transaction Successfull" || data?.status === "Transaction failed") {
      getHistory();
      stopPolling();
      discoveryCtx.updateTransactionStatus(data?.status === "Transaction Successfull" ? "COMPLETED" : "RETRY")
      discoveryCtx.updateLoading(false);
    }

    console.log("brandAuditSocketData", data);

    switch (type) {
      case "rank":
        if (!response) return console.warn("Missing response for 'rank'");
        response = { ...response, request_id: data.id };
        const sorceRank = [...Object.keys(response?.sources?.rank || {})];
        discoveryCtx.updateRankScores({
          req: commonReq,
          res: response,
          completedTaskCount,
        });
        discoveryCtx.updateSources({
          res: sorceRank,
          req: commonReq,
          completedTaskCount,
        });
        break;

      case "sentiment":
        if (!response || !transaction || !request?.category) {
          console.warn("Invalid sentiment data:", response, transaction);
          return;
        }

        const entity = { ...response?.data }?.[0];
        const entityRecord = response?.data?.[0];
        console.log("SentimentBrandaudit", entity, entityRecord, response)
        const brandRes = response?.error
          ? { error: "something went wrong" }
          : {
            name: entity?.name || "Unknown",
            favorability: entity?.score ?? 0,
            extras: response.extras,
          };
        const sorceSentiment = [
          ...Object.keys(response?.sources?.sentiment || {}),
        ];
        const competitors =
          discoveryCtxRef.current?.competitors?.[request.category] || [];
        let index = competitors.findIndex(
          (item) => item.name?.toLowerCase() == entity?.name?.toLowerCase()
        );
        if (transaction?.brand === entity?.name) index = -1;

        discoveryCtx.updateBrandScores({
          req: commonReq,
          res: { data: brandRes, index: index + 1 },
          completedTaskCount
        });
        discoveryCtx.updateSources({
          res: sorceSentiment,
          req: commonReq,
          completedTaskCount,
        });
        break;

      case "signalStrength":
        if (!response) return console.warn("Missing response for 'signalStrength'");
        const negativeAttributes = response?.aggregatedNegatives || [];
        const positiveAttributes = response?.aggregatedPositives || [];
        const sourcesPosNeg = [
          ...(response?.aggregatedPositiveSources || []),
          ...(response?.aggregatedNegativeSources || []),
        ];

        discoveryCtx.updatePositiveNegativeAttributes({
          res: {
            name: data?.brand,
            positives: positiveAttributes.slice(0, 10),
            negatives: negativeAttributes.slice(0, 10),
          },
          req: commonReq,
          completedTaskCount
        });

        discoveryCtx.updateSources({
          res: sourcesPosNeg,
          req: commonReq,
          completedTaskCount,
        });

        break;

      case "categoryDimension":
        if (!response) return console.warn("Missing response for 'categoryDimension'");
        discoveryCtx.updateCategoryDimensions({
          data: response?.data || [],
          summary: response?.summary || "",
          category: request?.category,
          llm: request?.llm,
          completedTaskCount
        });

        const sourcesCategoryDim = [
          ...Object.keys(response?.sources?.category || {}),
          ...Object.keys(response?.sources?.dimension || {}),
        ];
        discoveryCtx.updateSources({
          res: sourcesCategoryDim,
          req: commonReq,
          completedTaskCount,
        });

        break;
      case "taxonomy":
        if (!response) return console.warn("Missing response for taxonomy");
        discoveryCtx.updatedTaxonomies({
          res: response.data,
          req: {
            category: category,
            llm: llm
          },
          completedTaskCount
        });
        break

      case "core-attribute":
        if (!Array.isArray(coreAttributeData)) {
          console.warn("Expected array for core-attribute:", coreAttributeData);
          return;
        }
        console.log("CoreattributeDetails", coreAttributeData)
        // Grouping by category + llm
        if(coreAttributeData?.length == 4){
          const groupedByCategoryAndLlm = coreAttributeData.reduce(
            (acc, item) => {
              const category = item?.category;
              const llm = item?.llm;
              if (!category || !llm) return acc;

              const key = `${category}__${llm}`; // unique key per group
              if (!acc[key]) acc[key] = [];
              acc[key].push(item);

              return acc;
            },
            {}
          );

          // Debug log
          // Process each group
          Object.entries(groupedByCategoryAndLlm).forEach(([key, items]) => {
            const [category, llm] = key.split("__");
            const resData = items
              .filter((res) => res?.response)
              .map((res) => res.response);

            let coreAttributeSummary = "";
            let category_averages = resData[0]?.category_averages || {};
            let products = [];
            const sources = [];

            for (let res of resData) {
              if (!res?.error) {
                coreAttributeSummary += res.products?.[0]?.summary || "";
                coreAttributeSummary += "\n\n";
                products.push(res.products?.[0]);
                sources.push(
                  ...Object.keys(res.sources?.category || {}),
                  ...Object.keys(res.sources?.product || {})
                );
              }
            }

            const competitors =
              discoveryCtxRef?.current?.competitors?.[category] || [];
            const entities = competitors?.map((item) => item.name);
            entities.unshift(
              discoveryCtxRef.current?.competitors?.["default"]?.[0]?.name || ""
            );
            const sortedProducts = [];
            entities.forEach((company) => {
              const normalizedCompany = company.toLowerCase().replace(/\s+/g, "");
              for (const product of products) {
                const normalizedProductName = product.name
                  .toLowerCase()
                  .replace(/\s+/g, "");
                if (normalizedProductName === normalizedCompany) {
                  sortedProducts.push(product);
                  break;
                }
              }
            });

            discoveryCtx.updateCoreAttributes({
              category_averages,
              products: sortedProducts,
              summary: coreAttributeSummary,
              category,
              llm,
              completedTaskCount,
            });

            discoveryCtx.updateSources({
              res: sources,
              req: commonReq,
              completedTaskCount,
            });
          });
        }
        break;


      case "description":
        if (!response?.data) return console.warn("Missing response.data for description");
        discoveryCtx.updateBrandDescription({
          res: response.data,
          req: { category: category, llm: llm },
          completedTaskCount
        });
        break;

      case "theme":
      case "snippet": {
        const isTheme = type === "theme";
        const snippetData = response?.data?.data;

        if (!Array.isArray(snippetData)) {
          console.warn(`${type} data not in expected array format:`, snippetData);
          return;
        }

        if (!llm || !category) {
          console.warn("Missing llm or category for theme/snippet");
          return;
        }

        const store = isTheme
          ? discoveryCtxRef.current?.brand_snippets
          : discoveryCtxRef.current?.brand_themes;

        const updateFn = isTheme
          ? discoveryCtx.updateBrandSnippets
          : discoveryCtx.updatedBrandThemes;

        const currentList = store?.[llm]?.[category] || [];
        const updatedList = [...currentList, snippetData];
        updateFn({
          res: updatedList,
          req: { category: category, llm: llm },
          completedTaskCount
        });

        break;
      }

      default:
        console.warn(`Unhandled socket data type: ${type}`);
    }
  };

  let currentBrandSnippets = [];
  let currentBrandThemes = [];
  const coreAttributeMap = {};
  const loadSocketData = (socketResponse, requestObj, currentTransactionId, completedTaskCount) => {
    if (!socketResponse || typeof socketResponse !== 'object') {
      console.error("Invalid socket response:", socketResponse);
      return;
    }
    let {
      type,
      request,
      response,
      category,
      llm,
      market,
      status,
      transactionId,
    } = socketResponse;
    if (!type || !request) {
      console.error("Incomplete socket response:", response);
      return;
    }
    if (status !== 'COMPLETED') {
      return false
    }
    if (parseInt(transactionId) !== parseInt(currentTransactionId)) return;
    const commonReq = {
      category: category,
      llm: llm,
      market: market,
    };
    console.log("LoadBrandAuditData", response)
    switch (type) {
      case "rank":
        if (!response) return console.warn("Missing response for rank");
        response = { ...response, request_id: socketResponse.id };
        const sorceRank = [...Object.keys(response?.sources?.rank || {})];
        discoveryCtx.updateRankScores({
          req: commonReq,
          res: response,
          completedTaskCount,
        });
        discoveryCtx.updateSources({
          res: sorceRank,
          req: commonReq,
          completedTaskCount,
        });
        break;

      case "sentiment":
        if (!response) return console.warn("Missing response/Transaction for sentiment");

        // const entity = response?.data?.[0];
        const entity = { ...response?.data }?.[0];
        const brandRes = response?.error
          ? { error: "something went wrong" }
          : {
            name: entity?.name || "Unknown",
            favorability: entity?.score ?? 0,
            extras: response.extras,
          };
        const sorceSentiment = [
          ...Object.keys(response?.sources?.sentiment || {}),
        ];
        let index = -1;
        try {
          requestObj.competitor?.[request.category]?.forEach((item, idx) => {
            if (item.name?.toLowerCase() == entity?.name?.toLowerCase()) {
              index = idx;
            }
          }
          );
          if (requestObj.brand === entity?.name) index = -1;
        } catch (err) {
          console.warn("Error calculating sentiment index:", err);
        }

        discoveryCtx.updateBrandScores({
          req: commonReq,
          res: { data: brandRes, index: index + 1 },
          completedTaskCount
        });
        discoveryCtx.updateSources({
          res: sorceSentiment,
          req: commonReq,
          completedTaskCount,
        });
        break;

      case "signalStrength":
        if (!response) return console.warn("Missing response for signalStrength");

        const negativeAttributes = response?.aggregatedNegatives || [];
        const positiveAttributes = response?.aggregatedPositives || [];
        const sourcesPosNeg = [
          ...(response?.aggregatedPositiveSources || []),
          ...(response?.aggregatedNegativeSources || []),
        ];

        discoveryCtx.updatePositiveNegativeAttributes({
          res: {
            name: socketResponse?.brand,
            positives: positiveAttributes.slice(0, 10),
            negatives: negativeAttributes.slice(0, 10),
          },
          req: commonReq,
          completedTaskCount
        });

        discoveryCtx.updateSources({
          res: sourcesPosNeg,
          req: commonReq,
          completedTaskCount,
        });
        break;

      case "categoryDimension":
        if (!response) return console.warn("Missing response for categoryDimension");

        discoveryCtx.updateCategoryDimensions({
          data: response?.data,
          summary: response?.summary,
          category: request?.category,
          llm: request?.llm,
          completedTaskCount
        });

        const sourcesCategoryDim = [
          ...Object.keys(response?.sources?.category || {}),
          ...Object.keys(response?.sources?.dimension || {}),
        ];

        discoveryCtx.updateSources({
          res: sourcesCategoryDim,
          req: commonReq,
          completedTaskCount,
        });
        break;

      case "taxonomy":
        if (!response) return console.warn("Missing response for taxonomy");
        discoveryCtx.updatedTaxonomies({
          res: response.data,
          req: {
            category: category,
            llm: llm
          },
          completedTaskCount
        });
        break;

      case "core-attribute":
        if (!response || !category || !llm) return console.warn("Missing data for core-attribute");

        const key = `${llm}__${category}`;

        if (!coreAttributeMap[key]) {
          coreAttributeMap[key] = [];
        }

        coreAttributeMap[key].push(response);
        console.log("coreAttributeMap", key, coreAttributeMap[key]);
        let competitors = requestObj?.competitor?.[category]?.map((item) => item.name);
        let brand = requestObj?.competitor?.['default']?.[0].name;
        if (competitors) {
          competitors.unshift(brand);
        } else {
          competitors = [];
        }

        if (coreAttributeMap[key].length === 4) {
          const group = coreAttributeMap[key];
          let coreAttributeSummary = "";
          const products = [];
          const sources = [];

          const category_averages = group[0]?.category_averages;

          for (const res of group) {
            if (!res?.error && Array.isArray(res?.products)) {
              coreAttributeSummary += res.products?.[0]?.summary || "";
              coreAttributeSummary += "\n\n";
              products.push(res.products?.[0]);
              sources.push(
                ...Object.keys(res?.sources?.category || {}),
                ...Object.keys(res?.sources?.product || {})
              );
            }
          }

          let sortedProducts = [];

          for (const company of competitors) {
            const normalizedCompany = company.toLowerCase().replace(/\s+/g, "");
            for (const product of products) {
              const normalizedProductName = product.name
                .toLowerCase()
                .replace(/\s+/g, "");
               if (normalizedProductName === normalizedCompany) {
                sortedProducts.push(product);
                break;
              }
            }
          }

          discoveryCtx.updateCoreAttributes({
            category_averages,
            products: sortedProducts,
            summary: coreAttributeSummary,
            category,
            llm,
            completedTaskCount
          });

          discoveryCtx.updateSources({
            res: sources,
            req: commonReq,
            completedTaskCount,
          });

          delete coreAttributeMap[key];
        }
        break;
      case "description":
        if (!response?.data) return console.warn("Missing response.data for description");
        discoveryCtx.updateBrandDescription({
          res: response.data,
          req: { category: category, llm: llm },
          completedTaskCount
        });
        break;

      case "theme":
      case "snippet":
        const isTheme = type === "theme";
        const dataSnippet = response?.data?.data;

        if (!Array.isArray(dataSnippet)) {
          console.warn(`${type} response is not a valid array:`, dataSnippet);
          return;
        }

        if (!llm || !category) {
          console.warn("Missing llm/category for", type);
          return;
        }

        const targetStore = isTheme ? currentBrandSnippets : currentBrandThemes;
        const contextMethod = isTheme
          ? discoveryCtx.updateBrandSnippets
          : discoveryCtx.updatedBrandThemes;

        if (!targetStore[llm]) targetStore[llm] = {};
        if (!targetStore[llm][category]) targetStore[llm][category] = [];

        // Append entire array as a sub-array
        targetStore[llm][category] = [
          ...targetStore[llm][category],
          dataSnippet,
        ];

        contextMethod({
          res: targetStore[llm][category],
          req: { category, llm },
          completedTaskCount
        });
        break;


      default:
        console.warn(`Unhandled socket data type: ${type}`);
    }
  };
  function tabChangeHandler(val) {
    setTabSelected(val);
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");
    const type = searchParams.get("type");
    const customer_id = searchParams.get("customer_id");
    if (id && type && customer_id && !cancelTransaction) {
      loadBrandAudit(id, type,customer_id, false);
    }
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      if (rankScoreAbortCtrRef.current) {
        rankScoreAbortCtrRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);

  async function loadBrandAudit(id, type, customer_id, refreshRecord) {
    try {
      api.get(
        `${webSocketBaseURL}/brandAudit/${customer_id}/${id}`
      ).then((response) => {
        if (response?.data?.transactionStatus !== "PENDING") {
          // setExternalReportLoading(true);
          if (refreshRecord) {
            currentBrandSnippets = [];
            currentBrandThemes = [];
            discoveryCtx.refreshState();
          } else {
            discoveryCtx.resetState();
          }
          discoveryCtx.updateTransactionId(id);
          discoveryCtx.updateId(id);
          let requestObj = response?.data.task[0].request_object
          let competitors = requestObj.competitor;
          let { transactionStatus, completedTaskCount } = response?.data || {};
          const totalTasks = discoveryCtxRef?.current?.status?.totaltasks;
          competitors["default"] = [{ name: requestObj.brand, domain: requestObj.brandDomainName, variants: [], display_name: requestObj.brand }];
          discoveryCtx.updatedCompetitors(competitors);
          discoveryCtx.updateTransactionStatus(response?.data.transactionStatus);
          discoveryCtx.updateEntity(requestObj.brand);
          discoveryCtx.updateMarket(requestObj.market);
          discoveryCtx.updateCategory(requestObj.category);
          discoveryCtx.updateSelectedLLM(requestObj.primaryLLM);
          discoveryCtx.updateLLM(requestObj.llm);
          discoveryCtx.updateType(type);
          discoveryCtx.updatePrimaryLLM(requestObj.primaryLLM);
          discoveryCtx.updateName(`${requestObj.brand} Brand Overview`);
          discoveryCtx.updatedLaunched(true);
          discoveryCtx.initializeStatus();
          if (
            ["COMPLETED", "RETRY"].includes(transactionStatus) ||
            completedTaskCount === totalTasks
          ) {
            getHistory();
            stopPolling();
            discoveryCtx.updateLoading(false);
          }

          for (const record of response?.data.task) {
            loadSocketData(record, requestObj, id, completedTaskCount);
          }
        }
      })
        .catch((error) => {
          console.error("API call failed:", error);
          if (error.message === "Network Error") {
            toast.warn("Please check your network connection");
          } else if (error.code === "ECONNABORTED") {
            toast.warn("Request timed out. Please try again");
          } else {
            toast.error("Failed to load discovery report. Please check if URL is correct");
          }
        })
    } catch (error) {
      toast.error(
        "Failed to load BrandAudit Data. Please check if URL is correct"
      );
    } finally {
      setExternalReportLoading(false);
    }
  }

  //start polling after discovery launch
  const startPolling = (transactionId, type) => {
    if (pollingRef.current) clearInterval(pollingRef.current);

    pollingRef.current = setInterval(() => {
      console.log("Calling transaction API...");
      loadBrandAudit(transactionId, type,user.customer_id, true);
    }, 5*60 * 1000); // 5 minutes
  };
  const stopPolling = () => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
      console.log("Stopped polling");
    }
  };

  useEffect(() => {
    return () => {
      if (pollingRef.current) clearInterval(pollingRef.current);
    }
  }, [])

  useEffect(() => {
    if (!inputValues.brand || !inputValues.category) return;
    // getCompetitors();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [inputValues]);

  let coreAttributesSummary = "";
  let categoryDimensionsSummary = "";
  let productDimensionSummary = "";
  if (
    discoveryCtx?.core_attributes &&
    Object.keys(discoveryCtx?.core_attributes).length > 0
  ) {
    coreAttributesSummary = discoveryCtx.core_attributes.summary;
  }
  if (
    discoveryCtx?.category_dimensions &&
    Object.keys(discoveryCtx?.category_dimensions).length > 0
  ) {
    categoryDimensionsSummary = discoveryCtx.category_dimensions.summary;
  }

  if (
    discoveryCtx?.taxonomies &&
    Object.keys(discoveryCtx?.taxonomies).length > 0
  ) {
    productDimensionSummary = discoveryCtx.taxonomies.summary;
  }

  let competitors = discoveryCtx.competitors;

  const exportToPDF = useReactToPrint({
    contentRef: pdfRef,
    documentTitle: `${entity} Overview`,
    removeAfterPrint: true,
    pageStyle: `
      @page {
        size: 380mm 400mm;
        margin-left: 10mm;
        margin-right: 10mm;
        margin-bottom: 5mm;
        margin-top: 15mm;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact; /* Ensures accurate color printing */
        }
      }
    `,
  });
  console.log("discoveryCtxindicator", discoveryCtx);
  function ProgressIndicator({ total, completed }) {
    console.log("ProgressIndicator", total, completed);
    const progressPercentage = (completed / total) * 100;

    return (
      <div className={classes.progressIndicator}>
        <div className={classes.progressBar}>
          <div
            className={classes.progressFill}
            style={{
              width: `${progressPercentage}%`
            }}
          ></div>
        </div>
        <div className={classes.progressText}>
          {completed} of {total} tasks completed
        </div>
      </div>
    );
  }
  async function generateReport(request_type) {
    let date = new Date();
    const shortMonth = date.toLocaleString("en-US", { month: "short" });

    let dateFormate = ` ${shortMonth} ${date.getDate()}, ${date.getFullYear()}`;

    try {
      const primaryLLM = LLM_OPTIONS.find(
        (opt) => opt.value === discoveryCtx.primary_llm
      )?.name;
      const otherllm = discoveryCtx.llm
        .map((val) => LLM_OPTIONS.find((opt) => opt.value === val)?.name)
        .filter((name) => name && name !== primaryLLM);
      const uniqueCompetitorBrands = discoveryCtx.competitors[
        discoveryCtx.category[0]
      ].map((comp) => comp.name);
      uniqueCompetitorBrands.unshift(entity);
      setLoading(true);
      const frontend_build_version = localStorage.getItem(
        "frontend_build_version"
      );
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("user");
      const payload = {
        isBrand: discoveryType === "brand",
        request_type: request_type ?? "brand-audit",
        transactionID: discoveryCtx.state.transactionId,
        brand: entity,
        category: discoveryCtx.category,
        market: discoveryCtx.markets[0],
        primaryLLM: primaryLLM,
        llm: otherllm,
        uniqueCompetitorBrands,
        frontend_build_version,
        selectedSection:Object.values(discoveryCtx?.state?.selectedSection),
        tab:tab,
        filter:filterKey,
        token,
        user,
      };
      console.log(payload);

      const blob = await api.post(
        "/llm-reporting/generate/brandaudit",
        payload,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(blob.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "BrandAudit.pptx";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  const brandAuditCall = async (values) => {
    const marketArray =
      Array.isArray(values.market) && values.market.length > 0
        ? values.market
        : ["General Market"];
    let category_taxonomies;
    if (discoveryCtx.type == "product") {
      category_taxonomies = discoveryCtx.category_taxonomies ?? discoveryCtx.category_taxonomies;
    }
    const payload = {
      user_id: user.customer_id,
      brand: values.brand,
      market: marketArray,
      type: discoveryCtx.type,
      llm: values.llm,
      category: values.category,
      primaryMarket: values.market[0],
      primaryLLM: discoveryCtx.primary_llm,
      competitor: competitors,
      request_type: "brandAudit",
      shouldProcessImmediately: "true",
      isMock: values.isMock,
      brandDomainName: values.domain,
      customTaxonomy: category_taxonomies
    }

    try {
      const response = await api.post(
        `${webSocketBaseURL}/brand-audit`,
        payload
      );
      getHistory();
      const transactionId = response?.data?.transaction_id;
      if (transactionId) {
        startPolling(transactionId, discoveryCtx.type);
      }
      if (showLaunchMessage !== "true") {
        setShowLunchDialog(true);
      }
      discoveryCtx.updateTransactionId(transactionId);
      discoveryCtx.updateId(transactionId)
      if (!transactionId) {
        console.error("Transaction ID not returned");
        return;
      }
    } catch (error) {
      console.log("responseBrandAudit", error);
    }
  };

  const selectReportSection = () => {
    discoveryCtx.showReportCheckbox(true);
  };

  return (
    <>
      {externalReportLoading && <LinearProgress />}
      <section
        className={classes.content_section}
        style={{
          gridTemplateRows: discoveryType === "category" && "auto 1fr",
        }}
      >
        <Header actionText={launchText} actionVariant="text" />
        <div
          className={classes.container}
          style={{
            gridTemplateColumns: discoveryType === "category" && "1fr",
          }}
        >
          <div className={classes.content}>
            <Tabs
              options={[]}
              onChange={tabChangeHandler}
              selected={tabSelected}
            />
            <Form
              warningText={warningText}
              setWarningText={setWarningText}
              cancelTransaction={cancelTransaction}
              setCancelTransaction={setCancelTransaction}
              stopPolling={stopPolling}
              id="discovery"
              onReset={() => {
                setInputValues((prevValues) => {
                  return {
                    ...prevValues,
                    brand: "",
                    category: "",
                    market: "",
                    llm: "",
                  };
                });
                setWarningText("");
              }}
              onSubmit={(values) => {
                if (launchesRemaining == 0 && !isSpecial) {
                  toast.warn(
                    `You have reached your ${launchLimitFrequency} limit`
                  );
                  return;
                }
                if (!isSpecial) updateLaunches();
                if (externalReportLoading) return;

                let competitors = { ...discoveryCtx.competitors, 'default': [{ name: values.brand, domain: values.domain }] }

                discoveryCtx.resetState();
                discoveryCtx.updateEntity(values.brand);
                discoveryCtx.updatedCompetitors(competitors);
                discoveryCtx.updateMarket(
                  values.market.length > 0 ? values.market : ["General Market"]
                );
                discoveryCtx.updateCategory(values.category);
                discoveryCtx.updateLLM(values.llm);
                discoveryCtx.updateSelectedLLM(values.primaryLLM);
                discoveryCtx.updateSelectedMarket(
                  values.market.length > 0
                    ? values.market[0]
                    : ["General Market"]
                );
                discoveryCtx.updateSelectedCategory(values.category[0]);
                discoveryCtx.updateType(discoveryCtx.type);
                discoveryCtx.updateName(`${values.brand} Brand Overview`);
                discoveryCtx.updatePrimaryLLM(values.primaryLLM)
                setTimeout(() => {
                  discoveryCtx.updatedLaunched(true);
                  discoveryCtx.updateLoading(true);
                  discoveryCtx.initializeStatus();
                  setInputValues(values);
                  setTimeout(() => {
                    brandAuditCall(values)
                  }, 500)

                }, 500);
              }}
              onTypeChanged={(val) => {
                setInputValues((prevVals) => {
                  return {
                    ...prevVals,
                    type: val,
                  };
                });
              }}
            />
          </div>
          {discoveryType !== "category" && (
            <div className={classes.history}>
              <History
                filter={discoveryCtx.type}
                setCancelTransaction={setCancelTransaction}
                startPolling={startPolling}
              />
            </div>
          )}
        </div>
        {discoveryCtx.is_launched && (
          <div className={classes.result} id="print-pdf" ref={pdfRef}>
            {discoveryCtx.state.transactionStatus === "RETRY" && (
              <div className={classes.failMessage} >
                <span style={{ fontSize: "18px", marginRight: "8px" }}>⚠️</span>
                Some LLM requests failed. Our team will retry the failed
                requests and fix this report.
              </div>
            )}
            <div className={classes.hideOnPrint}>
              <ProgressIndicator total={discoveryCtx.status.totaltasks} completed={discoveryCtx.status.completedtasks} />
            </div>
            <PDFHeader />
            <BrandScore
              entity={entity}
              competitors={competitors}
              llms={discoveryCtx.llm}
              market={discoveryCtx?.markets?.[0]}
              categories={discoveryCtx.category}
            />
            {/* 
            {discoveryType === "brand" && discoveryCtx?.core_attributes && (
              <div className={classes.section_summary}>
                <div className={classes.flex_one}>
                  {competitors.length > 0 && (
                    <CoreAttributes
                      category={inputValues.category}
                      entity={entity}
                    />
                  )}
                </div>
                <div className={classes.flex_one}>
                  <AIGenerated
                    edit
                    text={coreAttributesSummary}
                    loading={coreAttributesSummary === ""}
                    firebaseNode="core_attributes"
                  />
                </div>
              </div>
            )}
 
            {discoveryType === "category" && (
              <div className={classes.section_summary}>
                <div className={classes.flex_one}>
                  {competitors && competitors.length > 0 && (
                    <CategoryDimensions category={inputValues.category} />
                  )}
                </div>
                <div className={classes.flex_one}>
                  <AIGenerated
                    edit={discoveryType != "category" || !discoveryCtx.loading}
                    text={categoryDimensionsSummary}
                    loading={categoryDimensionsSummary === ""}
                    firebaseNode="category_dimensions"
                  />
                </div>
              </div>
            )}

            {(discoveryType === "product" || discoveryType === "category") && (
              <div className={classes.section_summary}>
                <div className={classes.flex_one}>
                  {competitors && competitors.length > 0 && <Taxonomy />}
                </div>
                <div className={classes.flex_one}>
                  <AIGenerated
                    edit={discoveryType != "category" || !discoveryCtx.loading}
                    text={productDimensionSummary}
                    loading={productDimensionSummary === ""}
                    firebaseNode="taxonomies"
                  />
                </div>
              </div>
            )}

            {discoveryType === "category" && (
              <div className={classes.product_recommendation_container}>
                {competitors && competitors.length > 0 && <ProductSpecs />}
              </div>
            )}

            <div className="page-break print-only" />
            {discoveryType != "category" && (
              <div className={classes.section_summary}>
                <div className={classes.flex_one}>
                  {competitors && competitors.length > 0 && (
                    <CategoryDimensions
                      category={inputValues.category}
                      entity={entity}
                    />
                  )}
                </div>
                <div className={classes.flex_one}>
                  <AIGenerated
                    edit={!discoveryCtx.loading}
                    text={categoryDimensionsSummary}
                    loading={categoryDimensionsSummary === ""}
                    firebaseNode="category_dimensions"
                  />
                </div>
              </div>
            )}
            <div className="page-break print-only" />
            {discoveryType != "category" && (
              <div className={classes.section}>
                <Sources />
              </div>
            )}
            {discoveryType !== "category" && (
              <div className={classes.section}>
                <RealtimeActions />
              </div>
            )}*/}
           {discoveryCtx.state.showReportCheckbox ? <SelectedComponent generateReport={generateReport}  loading={loading}/>:null}
            {discoveryCtx.state.transactionStatus === "COMPLETED" &&
              discoveryType != "category" && (
                <div className={`${classes.action_btn_group} no-print`}>
                  {/* <MUIButton onClick={exportToPDF}>Export</MUIButton> */}
                  {!discoveryCtx.state.showReportCheckbox && (
                    <MUIButton onClick={selectReportSection} loading={loading}>
                      {"Export Report"}
                    </MUIButton>
                  )}
                  {/* <MUIButton onClick={generateReport} loading={loading}>
                    Generate Report
                  </MUIButton> */}
                </div>
              )}
            <div className={classes.pagefooter}>
              <PDFFooter />
            </div>
          </div>
        )}
      </section>
      <Modal
        handleConfirm={() => setShowLunchDialog(false)}
        open={showLunchDialog}
        title=""
        showActions
        showLaunchDialog
      >
        Brand Audit report of {discoveryCtx?.entity} is under progress and will complete in background. Usually it takes 2-3 hours to complete. You can come back to this screens and check your report from history section
      </Modal>
    </>
  );
}
